"use client";

// /company: the letters, the updates, the reports. It keeps the root layout and
// wears the company's own ground (the blog room's pale lavender), so a hiccup
// never turns the page a different colour. Retries quietly, then a button. See
// components/brand/NettiError.tsx.

import { RouteError } from "../../components/brand/NettiError";
import { CO_GROUND } from "../../components/company/companyTheme";

export default function CompanyError(props: { error: Error & { digest?: string }; unstable_retry: () => void }) {
  return <RouteError {...props} where="company" rootStyle={{ ["--bg" as string]: CO_GROUND, background: CO_GROUND }} />;
}
